export default [
  {
    id: "visa",
    name: "resources.bookmakers.payment_methods.visa",
  },
  {
    id: "mastercard",
    name: "resources.bookmakers.payment_methods.mastercard",
  },
  {
    id: "paypal",
    name: "resources.bookmakers.payment_methods.paypal",
  },
  {
    id: "postepay",
    name: "resources.bookmakers.payment_methods.postepay",
  },
  {
    id: "skrill",
    name: "resources.bookmakers.payment_methods.skrill",
  },
  {
    id: "neteller",
    name: "resources.bookmakers.payment_methods.neteller",
  },
  {
    id: "bank_transfer",
    name: "resources.bookmakers.payment_methods.bank_transfer",
  },
  {
    id: "paysafecard",
    name: "resources.bookmakers.payment_methods.paysafecard",
  },
];
